function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappySelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 195.7,
    height: 195.7,
    viewBox: "0 0 195.7 195.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M97.85,195.7A97.85,97.85,0,1,1,195.7,97.85,97.85,97.85,0,0,1,97.85,195.7Z",
    transform: "translate(0 0)",
    style: {
      fill: "#13763c"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.49,
    cy: 71.74,
    rx: 13.49,
    ry: 17.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.42,
    cy: 71.74,
    rx: 13.49,
    ry: 17.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.85,156.08h-.2c-41.4-.13-58.85-43.16-59.58-45l8.27-3.23c.16.39,16,39.28,51.39,39.35s51.23-39,51.39-39.36l8.29,3.28c-.73,1.83-18.18,44.86-59.58,45Z",
    transform: "translate(0 0)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappySelected);
export default __webpack_public_path__ + "static/media/happy-selected.5990d5c5ed202e04968f188887575d00.svg";
export { ForwardRef as ReactComponent };